import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import App from '~/components/App'
import {i18n} from '~/plugins/i18n'
import Notifications from 'vue-notification'
import VueMask from 'v-mask'
import VueLocalStorage from 'vue-localstorage'
import vueDebounce from 'vue-debounce'

import '~/plugins'
import '~/filters'
import '~/components'

Vue.config.productionTip = false

Vue.use(Notifications)
Vue.use(VueMask)
Vue.use(VueLocalStorage)
Vue.use(vueDebounce)

new Vue({
  i18n,
  store,
  router,
  ...App
})
